var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { SubjectLabelCategory } from '@/models/SubjectLabelCategory';
import AreaSelect from '@/components/AreaSelect/AreaSelect.vue';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter';
import LabelValue from '@/components/LabelValue.vue';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
let AddSubjectLabelCategoryDialog = class AddSubjectLabelCategoryDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.category = null;
        this.selectedAreas = [];
        this.areas = [];
        this.currentStep = 1;
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeCategory();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.category = new SubjectLabelCategory();
        this.currentStep = 1;
        this.selectedAreas = [];
        this.areas = [];
    }
    onSubmit() {
        if (!this.category || !this.selectedAreas) {
            return;
        }
        const payload = {
            label: this.category.label,
            subjects: this.selectedAreas,
        };
        if (this.isEditing) {
            this.onUpdateCategory(payload);
        }
        else {
            this.onCreateCategory(payload);
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateCategory(payload) {
        try {
            await this.existingCategory.update(payload);
            this.$emit('subjectLabelCategoryUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateCategory(payload) {
        try {
            await new SubjectLabelCategory().create(payload);
            this.$emit('subjectLabelCategoryCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeCategory() {
        if (this.existingCategory) {
            this.category = this.existingCategory;
            this.selectedAreas = this.existingCategory.subjects ? this.existingCategory.subjects.map((subject) => subject.uuid) : [];
        }
        else {
            this.category = new SubjectLabelCategory();
        }
    }
    async fetchAreas() {
        this.isLoading = true;
        try {
            const response = await new Subject().all();
            this.selectedAreas.forEach((area) => {
                const foundArea = response.find((subject) => subject.id === area);
                if (foundArea) {
                    this.areas.push(foundArea);
                }
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get selectedLabelCategoriesText() {
        return this.areas.map((area) => area.name).join(', ');
    }
    get disabled() {
        switch (this.currentStep) {
            case 1:
                return !this.category || !this.category.label;
            case 2:
                return !this.selectedAreas.length;
            case 3:
                return false;
            default:
                return true;
        }
    }
    get submitButtonText() {
        return this.$tc('Save');
    }
    get isEditing() {
        return !!this.existingCategory;
    }
    get title() {
        return this.isEditing ? this.$tc('Edit tag category') : this.$tc('Add tag category');
    }
    // #endregion
    // #region @Watchers
    async onCurrentStepChange(newStep) {
        if (newStep === 3) {
            await this.fetchAreas();
        }
    }
    async onExistingCategoryChange() {
        this.isLoading = true;
        await this.initializeCategory();
        this.isLoading = false;
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof SubjectLabelCategory !== "undefined" && SubjectLabelCategory) === "function" ? _a : Object)
], AddSubjectLabelCategoryDialog.prototype, "existingCategory", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], AddSubjectLabelCategoryDialog.prototype, "onCurrentStepChange", null);
__decorate([
    Watch('existingCategory'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], AddSubjectLabelCategoryDialog.prototype, "onExistingCategoryChange", null);
AddSubjectLabelCategoryDialog = __decorate([
    Component({
        components: {
            DataTable,
            AreaSelect,
            AreaFilter,
            LabelValue,
        },
    })
], AddSubjectLabelCategoryDialog);
export default AddSubjectLabelCategoryDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
